import { FunctionComponent, memo } from 'react';
import { getCssVar } from '../../utils';
import { IconLabel } from '../IconLabel';

import classNames from 'classnames';
import classes from './Delta.module.scss';

const DELTA_MIN_BASE = 50;

interface DeltaLabelArgs {
  value: number;
  valuePrev: number;
}

interface DeltaProps {
  value: number;
  valuePrev: number;
  className?: string;
}

const getDeltaLabel = ({ value, valuePrev }: DeltaLabelArgs) => {
  const difference = Math.abs(value - valuePrev);

  if (valuePrev < DELTA_MIN_BASE) {
    return `${difference}`;
  }

  return `${Math.round((difference / valuePrev) * 100)}%`;
};

export const Delta: FunctionComponent<DeltaProps> = memo(({ value, valuePrev, className }) => {
  if (value === valuePrev) {
    return null;
  }

  const isTrendUp = value > valuePrev;

  return (
    <IconLabel
      className={classNames(classes['delta'], className)}
      iconSize={18}
      iconId={isTrendUp ? 'trend-up' : 'trend-down'}
      label={getDeltaLabel({ value, valuePrev })}
      color={isTrendUp ? '#0a7a4f' : getCssVar('--color-danger')}
      singleColor
      nonClickable
    />
  );
});
